import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'
import { Quotes } from './Quotes'
import { TradingForm } from './TradingForm'
import { getInstrumentsIsLoading } from '../../../../store/selectors'
import { Loader } from '../../../../components/Loader'
import { Balances } from './Balances'
import { TradingHistory } from './TradingHistory'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(4),
  },
  wrap: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 248px)',
  },
  navWrap: {
    margin: '32px 8px',
  },
}))

export const SpotTrading: FC = () => {
  const classes = useStyles()
  const isLoadingInstruments = useSelector(getInstrumentsIsLoading)

  return (
    <Grid container className={classes.container}>
      {/* <Grid container item xs={12} className={classes.wrap}> */}
      {/* {etag1 && etag2 ? <IframeMercurySSO etag1={etag1} etag2={etag2} /> : <Loader />} */}
      {/* </Grid> */}
      {isLoadingInstruments && <Loader />}
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} lg={4}>
          <Quotes />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <TradingForm />
        </Grid>
        <Grid item xs={12} sm={12} lg={4}>
          <Balances />
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TradingHistory count={5} />
        </Grid>
      </Grid>
    </Grid>
  )
}
